import { TranslateFunction } from 'react-localize-redux';

import { BasketError } from '../weborder/selectors/basketSelectors';
import { replaceCollectionWithPickup } from './localisationUtils';

export const getBasketErrorMessage = (
  basketError: BasketError,
  translate: TranslateFunction,
  countryCode: string,
): string => {
  switch (basketError) {
    case 'empty_basket':
      return translate('Your_basket_is_empty') as string;
    case 'below_minimum_amount':
      return translate('BasketError_orderBelowMinimumAmount') as string;
    case 'missing_pre_order_time':
      return replaceCollectionWithPickup(
        translate('BasketError_collectionTimeRequired') as string,
        countryCode,
      );
    case 'missing_restaurant_details':
    default:
      return translate('Unexpected_error_occurred') as string;
  }
};
